import { Component, Signal, WritableSignal, signal } from '@angular/core';
import { Chart, ChartCallbackFunction } from 'highcharts';
import { DataInterfaceComponent } from './data-interface.component';
import { LayoutBounds } from './layout';

@Component({
  template: '',
})
export abstract class ChartDataInterfaceComponent<TData, TSettings, TLayout = LayoutBounds>
  extends DataInterfaceComponent<TData, TSettings, TLayout>
{
  protected readonly chartRef: Signal<Chart> = signal(undefined);

  protected chartCallback: ChartCallbackFunction = (chart: Chart): void => {
    (this.chartRef as WritableSignal<Chart>).set(chart);
  };
}
